export const PrintIcon = (props) => (
  <svg fill="none" height={18} stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24" width={18} {...props}>
    <path
      d="M6.72 13.829a42.415 42.415 0 0 1 10.56 0M6.34 18h11.32m-11.32 0h-1.125A1.875 1.875 0 0 1 3 16.125V11.25c0-1.035.84-1.875 1.875-1.875h14.25c1.035 0 1.875.84 1.875 1.875v4.875A1.875 1.875 0 0 1 19.125 18H18m-11.66 0-.229 2.523a1.125 1.125 0 0 0 1.12 1.227h9.538a1.125 1.125 0 0 0 1.12-1.227L18 18m-9.535-8.625v-3.75c0-1.035.84-1.875 1.875-1.875h2.32c1.035 0 1.875.84 1.875 1.875v3.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
